/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptions(value) {
    if (!('QueryString' in value) || value['QueryString'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptionsFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'QueryString': json['QueryString'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptionsToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptionsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'QueryString': value['QueryString'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoVkontakteComLoginOptions.js.map